import { CoverageAmountsDataForEachType } from "../../../../data-model/coverage-details";
import AmountCard from "../amountCard/amountCard";

interface CoverageAmountsProps {
  coverageAmountsData: CoverageAmountsDataForEachType;
  coverageType: string;
  levelType?: string;
}

const CoverageAmounts = (props: CoverageAmountsProps) => {
  const generateCardHeader = (key: string) => {
    switch (key) {
      case "inNetwork":
        return `In Network`;
      case "outNetwork":
        return `Out Network`;
      case "noNetwork":
        return `No Network`;
      case "notApplicable":
        return `Not Applicable`;
      case "unknown":
        return `Unknown`;
      default:
        return `${key}`;
    }
  };

  return (
    <div className="coverage-amounts-layout">
      <div className="coverage-amounts-layout--header">
        {props.coverageType}
      </div>
      <div className="coverage-amounts-layout--content">
        {props.coverageAmountsData?.notApplicable && (
          <>
            {props.coverageAmountsData?.notApplicable?.length > 0 &&
              props.coverageAmountsData?.notApplicable.map((card, index) => (
                <div key={index} className="amount-card">
                  <AmountCard
                    key={index}
                    amountCardData={card.card}
                    amountCardHeader={generateCardHeader(card.amountType)}
                    subHeader={card.type}
                  />
                </div>
              ))}
          </>
        )}
        {props.coverageAmountsData?.noNetwork && (
          <>
            {props.coverageAmountsData?.noNetwork?.length > 0 &&
              props.coverageAmountsData?.noNetwork.map((card, index) => (
                <div key={index} className="amount-card">
                  <AmountCard
                    key={index}
                    amountCardData={card.card}
                    amountCardHeader={generateCardHeader(card.amountType)}
                    subHeader={card.type}
                  />
                </div>
              ))}
          </>
        )}
        {props.coverageAmountsData?.outNetwork && (
          <>
            {" "}
            {props.coverageAmountsData?.outNetwork?.length > 0 &&
              props.coverageAmountsData?.outNetwork.map((card, index) => (
                <div key={index} className="amount-card">
                  <AmountCard
                    key={index}
                    amountCardData={card.card}
                    amountCardHeader={generateCardHeader(card.amountType)}
                    subHeader={card.type}
                  />
                </div>
              ))}
          </>
        )}
        {props.coverageAmountsData?.inNetwork && (
          <>
            {" "}
            {props.coverageAmountsData?.inNetwork?.length > 0 &&
              props.coverageAmountsData?.inNetwork.map((card, index) => (
                <div key={index} className="amount-card">
                  <AmountCard
                    key={index}
                    amountCardData={card.card}
                    amountCardHeader={generateCardHeader(card.amountType)}
                    subHeader={card.type}
                  />
                </div>
              ))}
          </>
        )}
        {props.coverageAmountsData?.unknown && (
          <>
            {props.coverageAmountsData?.unknown?.length > 0 &&
              props.coverageAmountsData?.unknown.map((card, index) => (
                <div key={index} className="amount-card">
                  <AmountCard
                    key={index}
                    amountCardData={card.card}
                    amountCardHeader={generateCardHeader(card.amountType)}
                    subHeader={card.type}
                  />
                </div>
              ))}
          </>
        )}
      </div>
    </div>
  );
};

export default CoverageAmounts;
